var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flix-form-group"},[_c('b-flix-h3',{staticStyle:{"display":"block","margin-bottom":"20px"}},[_vm._v("Statistik")]),_c('b-flix-p',[_c('flix-statistic',{attrs:{"user":_vm.user}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }